import * as pubsub from "./pubsub";
let lStorage;
try {
    lStorage = localStorage;
    lStorage.getItem("test");
}
catch (ex) {
    // This can happen when user has blocked all cookies. Simulate localStorage by persisting data during
    // current session only. Reloading page will clear data.
    let dataCache = {};
    lStorage = {
        length: 0,
        clear: () => {
            dataCache = {};
        },
        key: (index) => Object.keys(dataCache)[index],
        removeItem: (key) => delete dataCache[key],
        getItem: (key) => dataCache[key],
        setItem: (key, value) => {
            dataCache[key] = value;
        },
        isSimulated: true,
    };
}
/**
 * Checks the availability of a true localStorage. If false, the local storage is simulated (i.e. not stored, but getItem and setItem will still work and save values for the duration of the session).
 * @returns true if localStorage is available, false if not (getItem/setItem emulates a transient localStorage).
 */
export function isLocalStorageAvailable() {
    return lStorage.isSimulated ? false : true;
}
/**
 * Get a `localStorage` item value.
 * @param key - Key to retrieve
 * @returns
 */
export function getItem(key) {
    return lStorage.getItem(key);
}
/**
 * Set a `localStorage` item.
 *
 * Publishes the change to topic `localStorage/<key>` to ensure `useSyncedLocalStorage` is notified.
 *
 * @param key - Key to set
 * @param value - New value. If null, the item is cleared.
 */
export function setItem(key, value) {
    if (value === null)
        lStorage.removeItem(key);
    else
        lStorage.setItem(key, value);
    pubsub.publish("localStorage/" + key, value);
}
